module.exports = __webpack_public_path__ + "static/BusinessProcessImprovement-d5c9f38391178e88eca0cfbd84d663dd.svg";